<script setup lang="ts">
  import { AvatarRoot } from 'radix-vue';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  import { avatarVariant } from '.';
  import type { AvatarVariants } from '.';

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class'];
      size?: AvatarVariants['size'];
      shape?: AvatarVariants['shape'];
    }>(),
    {
      shape: 'circle',
      size: 'sm',
    },
  );
</script>

<template>
  <AvatarRoot :class="cn(avatarVariant({ size, shape }), props.class)">
    <slot />
  </AvatarRoot>
</template>
